import {Select} from "antd";
import React, {useEffect} from "react";
import {useDataProvider} from "react-admin";

const { Option } = Select;

export interface BaseFilterDropdownProps {
    title?: string;
    allTitle?: string;
    placeholder: string;
    style?: React.CSSProperties;
    classNameTitle?: string;
    classNameSelect?: string;
    value?: any;
    onChange?: (value: any) => void;
    options?: any[];
    resource?: string;
}

export const BaseFilterDropdown: React.FC<BaseFilterDropdownProps> = ({
    title, allTitle, placeholder,
    style={ width: "250px" }, classNameTitle="filter-label", classNameSelect="filter-select",
    value, onChange, options, resource=null
}) => {
    const dataProvider = useDataProvider();
    const [selectOptions, setSelectOptions] = React.useState<any[]|null>(null);

    useEffect(() => {
        if (resource)
            dataProvider.getList(resource, {
                    pagination: {page: 1, perPage: 100},
                    sort: {field: 'name', order: 'asc'},
                    filter: {}
                })
                .then((response: any) => setSelectOptions(response?.data))
                .catch((error: any) => console.error(error))
        else if (options)
            setSelectOptions(options)
    }, [resource])

    return (
        <div style={{ flex: '0 0 auto', minWidth: '200px' }}>
            {title && <label className={classNameTitle}>{title}</label>}
            <Select
                placeholder={placeholder}
                style={style}
                className={classNameSelect}
                allowClear
                value={value}
                onChange={onChange}
            >
                <Option value={null}>{allTitle}</Option>
                {selectOptions?.map((model: any) => (
                    <Option key={model.id} value={model.id}>
                        {model.name}
                    </Option>
                ))}
            </Select>
        </div>
    )
};